<h2 class="order-confirmation-header-title">Thanks, you're all set</h2>
<div class="order-confirmation-header-desc">
  <p>
    We'll email your {{ isInsurance ? 'policy' : 'plan' }} documents shortly.
  </p>
</div>
